import { graphql } from "gql";

const ADMIN_CREATE_DISTRIBUTION_GROUP_MUTATION = graphql(`
  mutation AdminCreateDistributionGroup(
    $input: AdminCreateDistributionGroupInput!
  ) {
    adminCreateDistributionGroup(input: $input) {
      ...DistributionGroup
    }
  }
`);

export default ADMIN_CREATE_DISTRIBUTION_GROUP_MUTATION;
